export default {
  name: 'searchResults'
}



// WEBPACK FOOTER //
// ./src/mv/tracks.js